<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/invoice/list">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" lg="8" md="10" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td style="width:40%; padding-left: 20px;">
                        <p style="margin-top: 0;margin-bottom: 0;"><span style="white-space: pre; font-size: 10pt; text-alignment: left;">{{ getCompanySetting('CompanyAddress')}}</span></p>
                      </td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Inv Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.invoicenum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.invoicedate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                  </table>
                  <table style="width: 100%">
                  <tr>
                      <td><div align="center"><h3 class="ma-0"><b>{{ initvalue.invoicetype }}</b></h3></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text" cols="12">
                  <v-col cols="12">
                  
                  </v-col>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr>
                      <td style="width: 35%; vertical-align: text-top">
                        <div>
                          <span style="font-size: 11pt; font-weight: bold">{{ initvalue.invoicetype=='Rental Invoice' ? 'Tenant' : 'Customer' }}</span>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.invoicename }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.invoiceaddress }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ countries.lenght>0 ? countries.find(country=>country._id == initvalue.countryid)['countryname'] : '' }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.invoicephone }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.invoicemobile }}</p>
                        </div>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td style="width: 45%; text-align: right; vertical-align: text-top">
                        <table  style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Inv Type</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ initvalue.invoicetype }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Payment Terms</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ initvalue.invoicepayterms }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  locations.length>0 ? locations.find(location=>location._id == initvalue.locationid)['locationcode'] : '' }}</span></td>
                          </tr>
                          <tr v-if="initvalue.countryid!=null">
                            <td><span style="font-size: 11pt; font-weight: bold">Country</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  countries.length>0 ? countries.find(country=>country._id == initvalue.countryid)['countryname'] : '' }}</span></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div>&nbsp;&nbsp;</div>
                </v-row>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="2%">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="25%">Account</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Description</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid"></th>
                      <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid" width="15%">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transactions"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}</td>
                          <td>{{ accounts.length>0 ? accounts.find(account=>account._id==trans.accountid)['accountcode'] : '' }}</td>
                          <td>{{ trans.itemdesc }}</td>
                          <td>&nbsp;</td>
                          <td style="text-align: right">{{ trans.itemamount.toFixed(2) }}</td>
                        </tr>
                        <tr><td colspan="5" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td colspan="5" style="vertical-align: text-top; ">
                            <table width="100%">
                              <tr>
                                <td width="70%"><p style="margin:0"><strong>Note:</strong></p> <span style="white-space: pre">{{ initvalue.invoicenote }}</span></td>
                                <td width="30%" style="align-content: start;">
                                  <table width="100%">
                                    <tr>
                                      <td><span style="font-size: 11pt; font-weight: bold">Total: </span></td>
                                      <td v-if="initvalue.primaryCurrency!=initvalue.secondaryCurrency" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.invoicetotal).toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.secondaryCurrency }}</span></td>
                                      <td v-else style="text-align: right"><span></span></td>
                                      <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.invoicetotal.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr><td colspan="5">&nbsp;</td></tr>
                        <tr style="margin-top: 10; margin-bottom: 10;">
                          <td colspan="5">
                            <p style="margin-top: 0;margin-bottom: 0;"><strong>Attachments:</strong></p>
                            <p v-for="(file) in initvalue.files" v-bind:key="file._id" style="margin-top: 0;margin-bottom: 0;">
                              <a :href="file.fileurl" download>{{ file.filename }}</a>
                            </p>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
            isTrade: false,
            companysettings: null,
            currencysettings: null,
            taxsettings: null,
          };
        },
        computed: {
          ...mapState('Account', ['accounts']),
          ...mapState('Country', ['countries']),
          ...mapState('Location', ['locations']),
          ...mapState('SystemSetting', ['settings']),
          ...mapState('User', ['users']),
        },
        methods: {
          ...mapActions('Account', ['getAccountsRequest']),
          ...mapActions('Country', ['getCountriesRequest']),
          ...mapActions('Location', ['getLocationsRequest']),
          ...mapActions('SystemSetting', ['getSystemSettingsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            setTimeout(function() {
              mywindow.print();
            }, 1000);
            return;
          },
          convertCurrency(amount){
            let rate = parseFloat(this.initvalue.currencyRate);
            if(rate==null) rate = 0;
            return amount * rate;
          },
          getCompanySetting(name){
            console.log("!!!!")
            if(!this.companysettings) return;
            let result = this.companysettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },
          getCurrencySetting(name){
            if(!this.currencysettings) return;
            let result = this.currencysettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },
          getTaxSetting(name){
            if(!this.taxsettings) return;
            let result = this.taxsettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },

        },
        async created () {
          this.initvalue = this.$route.params;
          this.logo = getLogo(this.initvalue.companyid);
          if(!this.initvalue._id) this.$router.push({ name: 'InvoiceList' });
          if(this.accounts.length==0) await this.getAccountsRequest();
          if(this.countries.length==0) await this.getCountriesRequest();
          if(this.locations.length==0) await this.getLocationsRequest();
          if(this.settings.length==0) await this.getSystemSettingsRequest();
          if(this.users.length==0) await this.getUsersRequest();
          this.taxsettings = this.settings.find(setting=>setting.settingcode=='TaxSettings');
          this.companysettings = this.settings.find(setting=>setting.settingcode=='CompanySettings'); 
          this.currencysettings = this.settings.find(setting=>setting.settingcode=='CurrencySettings');  
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
